import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'child-cell',
  template: `
    <span class="cell-center"><button tabindex="-1" 
        (click)="invokeParentMethod()"
        class="reset-btn team_membership_reset_password icon-btn"
      ><img tabindex="0" 
        (click)="invokeParentMethod()" (keydown.enter)="invokeParentMethod()" [src]="resetIconPath" alt="Reset Icon" />
      </button></span
    >
  `,
  styles: [
    `
    .reset-btn {
      margin: 0px 0px 0px 0px;
      padding: 5px 10px;
      height: 30px;
      font-size: 16px;
    }
    .btn {
      line-height: 0.5;
    }
    `,
  ],
})
export class ResetPasswordRendererComponent implements ICellRendererAngularComp {
  public params: any;
  public resetIconPath: string;

  agInit(params: any): void {
    this.params = params;
  }
  constructor(private sanitizer: DomSanitizer) {
    this.resetIconPath = 'assets/images/reset_lock_icon.svg';
  }

  public invokeParentMethod() {
    this.params.context.componentParent.invokeParentMethod(this.params.data);
  }

  refresh(): boolean {
    return false;
  }
}